import { formatDate } from '../../utils/formatters';

const PageHeader = ({
  title,
  description,
  actions,
  showDate = true,
}) => {
  return (
    <div className="mb-6">
      {/* flex-wrap: auf schmalen Schirmen rutschen die Aktionen unter den Titel,
          statt rechts aus dem Bild zu laufen (Knopf war am Handy abgeschnitten). */}
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div className="min-w-0">
          <h1 className="text-2xl font-bold text-gray-900 dark:text-gray-100">{title}</h1>
          {description && (
            <p className="mt-1 text-sm text-gray-500">{description}</p>
          )}
        </div>
        <div className="flex items-center gap-4">
          {showDate && (
            <p className="hidden text-sm text-gray-500 md:block">
              {formatDate(new Date(), { weekday: 'long', day: '2-digit', month: 'long', year: 'numeric' })}
            </p>
          )}
          {actions && <div className="flex items-center gap-2">{actions}</div>}
        </div>
      </div>
    </div>
  );
};

export default PageHeader;
